import { Theme, ThemeMode } from '@amzn/storm-ui';
import { VIEW_TYPE } from 'src/app/slice';
import { squidInk } from 'src/colors';

export interface StyledComponentsPropWithTheme {
  theme: ChromeThemeStyles;
}

export interface ChromeThemeStyles extends Theme {
  header: {
    contextBar: {
      STANDARD: {
        backgroundColor: string;
        textColor: string;
      };
      INTERNAL_STANDARD: {
        backgroundColor: string;
        textColor: string;
      };
      FOCUS: {
        backgroundColor: string;
        textColor: string;
      };
    };
    utility: {
      icon: {
        backgroundColorHover: string;
        color: string;
        colorHover: string;
      };
    };
  };
  nav: {
    link: {
      color: string;
    };
    text: {
      color: string;
    };
    overlay: {
      backgroundColor: string;
    };
  };
}

export const getExtendedTheme = (
  theme: Theme,
  viewType: VIEW_TYPE,
): ChromeThemeStyles => {
  if (viewType === VIEW_TYPE.MOBILE) {
    if (theme.themeMode === ThemeMode.DARK) {
      // dark theme - mobile
      return {
        ...theme,
        header: {
          contextBar: {
            STANDARD: {
              backgroundColor: squidInk,
              textColor: theme.text.color.default,
            },
            INTERNAL_STANDARD: {
              backgroundColor: theme.color.lightBlue[900],
              textColor: theme.text.color.default,
            },
            FOCUS: {
              backgroundColor: theme.pageHeader.backgroundColor,
              textColor: theme.text.color.default,
            },
          },
          utility: {
            icon: {
              backgroundColorHover: theme.color.gray[1000],
              color: theme.icon.color.default,
              colorHover: theme.icon.color.secondary,
            },
          },
        },
        nav: {
          link: {
            color: theme.text.color.default,
          },
          text: {
            color: theme.text.color.default,
          },
          overlay: {
            backgroundColor: squidInk,
          },
        },
      };
    }
    // light theme - mobile
    return {
      ...theme,
      header: {
        contextBar: {
          STANDARD: {
            backgroundColor: squidInk,
            textColor: theme.text.color.inverted,
          },
          INTERNAL_STANDARD: {
            backgroundColor: theme.color.lightBlue[900],
            textColor: theme.text.color.inverted,
          },
          FOCUS: {
            backgroundColor: theme.pageHeader.backgroundColor,
            textColor: theme.text.color.default,
          },
        },
        utility: {
          icon: {
            backgroundColorHover: theme.color.gray[1000],
            color: theme.icon.color.inverted,
            colorHover: theme.icon.color.invertedHover,
          },
        },
      },
      nav: {
        link: {
          color: theme.text.color.default,
        },
        text: {
          color: theme.text.color.default,
        },
        overlay: {
          backgroundColor: squidInk,
        },
      },
    };
  }
  if (theme.themeMode === ThemeMode.DARK) {
    // dark theme - desktop
    return {
      ...theme,
      header: {
        contextBar: {
          STANDARD: {
            backgroundColor: theme.color.lightBlue[950],
            textColor: theme.text.color.default,
          },
          INTERNAL_STANDARD: {
            backgroundColor: theme.color.lightBlue[900],
            textColor: theme.color.gray[0],
          },
          FOCUS: {
            backgroundColor: theme.color.gray[0],
            textColor: theme.text.color.default,
          },
        },
        utility: {
          icon: {
            backgroundColorHover: theme.color.gray[1000],
            color: theme.icon.color.default,
            colorHover: theme.icon.color.secondary,
          },
        },
      },
      nav: {
        link: {
          color: theme.color.gray[900],
        },
        text: {
          color: theme.color.gray[900],
        },
        overlay: {
          backgroundColor: theme.surface.default,
        },
      },
    };
  }
  // light theme - desktop
  return {
    ...theme,
    header: {
      contextBar: {
        STANDARD: {
          backgroundColor: squidInk,
          textColor: theme.color.gray[0],
        },
        INTERNAL_STANDARD: {
          backgroundColor: theme.color.lightBlue[900],
          textColor: theme.color.gray[0],
        },
        FOCUS: {
          backgroundColor: theme.color.gray[0],
          textColor: theme.text.color.default,
        },
      },
      utility: {
        icon: {
          backgroundColorHover: theme.color.gray[1000],
          color: theme.icon.color.inverted,
          colorHover: theme.icon.color.invertedHover,
        },
      },
    },
    nav: {
      link: {
        color: theme.color.gray[900],
      },
      text: {
        color: theme.color.gray[900],
      },
      overlay: {
        backgroundColor: squidInk,
      },
    },
  };
};
